import { render, staticRenderFns } from "./UserLoginLogsDialog.vue?vue&type=template&id=565e3814&scoped=true"
import script from "./UserLoginLogsDialog.vue?vue&type=script&lang=js"
export * from "./UserLoginLogsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserLoginLogsDialog.vue?vue&type=style&index=0&id=565e3814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e3814",
  null
  
)

export default component.exports